import { useEffect } from "react";
import { useTheme } from "../context/ThemeContext";

export default function SEO({ title, description, schema, image, type = "website", noindex = false }) {
  const { seo } = useTheme();
  const indexing = seo?.search_indexing !== false && !noindex;
  useEffect(() => {
    const full = title ? `${title} — Humaira Crafts` : "HUMAIRA CRAFTS | Handcrafted Metal Home Décor";
    document.title = full;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:site_name", "HUMAIRA CRAFTS");
    setMeta("name", "twitter:card", "summary_large_image");
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }

    let robots = document.querySelector('meta[name="robots"]');
    if (!indexing) {
      setMeta("name", "robots", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }

    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = window.location.origin + window.location.pathname;

    let el = document.getElementById("page-schema");
    if (schema) {
      if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = "page-schema";
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(schema);
    } else if (el) {
      el.remove();
    }
  }, [title, description, schema, image, type, indexing, noindex]);
  return null;
}
